import { atom } from "recoil";

// MyPageの申込status
export const currentStatusState = atom({
  key: "currentStatusState",
  default: '',
});